import { render } from "./Death.vue?vue&type=template&id=4df5ee1e"
import script from "./Death.vue?vue&type=script&lang=js"
export * from "./Death.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jack/Develop/Inncom/LCY/2110.lcy.app.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__